<template>
    <div class="d-flex flex-column w-100">
        <b-modal @hidden="limparFormulario(), reiniciaModal()" size="lg" hide-footer id="modal-novo-usuario" centered
            :title="tituloModal">
            <div class="d-flex flex-column" v-if="mostrarBuscarPessoa">
                <div class="d-flex flex-column gap-sm">
                <div class="d-flex gap-sm">
                    <div class="d-flex gap-sm">
                        <label>Pessoa Jurídica:</label>
                        <input @input="limparFormularioEPesquisar('pessoaJuridica')" type="radio" value="pessoaJuridica" v-model="tipoPessoa">
                    </div>
                    <div class="d-flex gap-sm">
                        <label>Pessoa Física:</label>
                        <input @input="limparFormularioEPesquisar('pessoaFisica')" type="radio" value="pessoaFisica" v-model="tipoPessoa">
                    </div>
                </div>
                <div class="d-flex gap-sm w-100">
                    <div class="d-flex flex-column w-100">
                        <label>Pessoa Física:</label>
						<auto-complete-pessoa-fisica :disabled="tipoPessoa == `pessoaJuridica`" ref="filtroPessoaFisica2" @pessoaSelecionada="setaCpfPessoaFisicaPesquisada($event)"/>
					</div>
                </div>
                <div class="d-flex gap-sm w-100">
					<div class="d-flex flex-column w-100">
                        <label>Pessoa Jurídica:</label>
						<auto-complete-pessoa-juridica :disabled="tipoPessoa == 'pessoaFisica'" ref="filtroPessoaJuridica2" @pessoaSelecionada="setaCpfPessoaJuridicaPesquisada($event)"/>
                    </div>
                </div>
                <div class="d-flex gap-sm my-1">
                    <b-button variant="primary" @click="filtrarPessoas">Filtrar</b-button>
                    <b-button variant="secondary" @click="limparFiltros">Limpar</b-button>
                </div>
            </div>
            <b-table striped hover :items="pessoas" :fields="pessoasFields" show-empty :responsive="true"
                :busy="carregando">
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
				<template #empty >
                    <div class="d-flex">
                        <span class="mx-auto">
                        Nenhum Registro Encontrado
                    </span>
                    </div>
                </template>
				<template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(cpfCnpj)="data">
                    {{ data.item.cpf == null ? $options.filters.addMascara(data.item.cnpj, "cnpj") :
                        $options.filters.addMascara(data.item.cpf, "cpf") }}
                </template>
                <template #cell(dataInicio)="data">
                    {{ data.item.dataInicio == null ? "" :
                        $options.filters.moment(data.item.dataInicio).format("DD/MM/YYYY") }}
                </template>
                <template #cell(acao)="data">
                    <b-button @click="selecionarPessoa(data.item)">
                        Selecione
                    </b-button>
                </template>
            </b-table>
            <div class="d-flex">
                <b-pagination class="mx-auto" v-model="paginaAtualTabelaPessoas" :total-rows="numeroDeLinhasTabelaPessoas"
                    :per-page="pessoasPorPagina" @input="consultarPessoas"></b-pagination>
            </div>
            </div>
            <b-form v-if="!mostrarBuscarPessoa" class="d-flex flex-column gap-sm">
				<div class="mx-auto">
					<b-spinner v-show="carregandoBuscarPorId" variant="primary"></b-spinner>
				</div>
                <b-form-row v-if="!carregandoBuscarPorId">
                    <b-col cols="12" md="6">
                        <div class="d-flex flex-column w-100">
                            <label>Email:</label>
                            <input type="text"  v-model="email"
                                class="form-control" :disabled="idUsuario != 0">
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                    <div class="d-flex flex-column w-100">
                            <label>Permissão:</label>
                            <select  v-model="permissoes" class="form-control">
                                <option value selected disabled>Selecione</option>
                                <option value="ADMINISTRADOR">Administrador</option>
                                <option value="CLIENTE">Cliente</option>
                            </select>
                    </div>
                    </b-col>
                </b-form-row>
				<b-form-row v-if="idUsuario == 0" >
					<b-col md="6" smm="12">
						<label>Senha:</label>
						<input type="password" class="form-control" v-model="senha">
					</b-col>
					<b-col md="6" smm="12">
						<label>Confirmação Senha:</label>
						<input type="password" class="form-control" v-model="confirmacaoSenha">
					</b-col>
				</b-form-row>
                <b-form-row  v-if="verificaTipoPessoa(pessoaSelecionada) == 'pessoaFisica' && !carregandoBuscarPorId">
                    <b-col cols="12" md="6">
                        <div class="d-flex flex-column w-100">
                            <label>Nome:</label>
                            <input type="text" disabled v-model="pessoaSelecionada.nome"
                                class="form-control">
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="d-flex flex-column w-100">
                            <label>Cpf:</label>
                            <input class="form-control" type="text" v-model="pessoaSelecionada.cpf"
                                disabled v-mask="'###.###.###-##'">
                        </div>
                    </b-col>
                </b-form-row>
				<b-form-row v-if="verificaTipoPessoa(pessoaSelecionada) == 'pessoaJuridica' && !carregandoBuscarPorId">
                    <b-col cols="12" md="6" >
                        <div class="d-flex flex-column w-100">
                            <label>Razão Social:</label>
                            <input type="text" disabled v-model="pessoaSelecionada.razaoSocial"
                                class="form-control">
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="d-flex flex-column w-100">
                            <label>Cnpj:</label>
                            <input class="form-control" type="text" v-model="pessoaSelecionada.cnpj"
                            disabled v-mask="'##.###.###/####-##'">
                        </div>
                    </b-col>
                </b-form-row>
                <div v-if="!carregandoBuscarPorId">
                    <b-button variant="success" @click="salvarUsuario" :disabled="carregandoSalvarOficial">
                        <b-spinner v-if="carregandoSalvarOficial" variant="light"></b-spinner>
                        <span v-if="!carregandoSalvarOficial">
                             Salvar
                        </span>
                    </b-button>
                </div>
            </b-form>
    </b-modal>
</div>
</template>

<script>
import Pessoa from "../../model/Pessoa.js";
import PessoaService from "../../service/PessoaService.js";
import AuthService from "../../service/AuthService.js";
import UsuarioService from "../../service/UsuarioService.js";
import AutoCompletePessoaFisica from "../pessoa/AutoCompletePessoaFisica.vue";
import AutoCompletePessoaJuridica from "../pessoa/AutoCompletePessoaJuridica.vue";

export default {
	components: { AutoCompletePessoaFisica, AutoCompletePessoaJuridica },
	name: "GerenciarUsuarios",
	data() {
		return {
			email: "",
			permissoes: "",
			idPessoa: 0,

			carregandoSalvarOficial: false,
			carregando: false,

			carregandoBuscarPorId: false,

			usuario: null,
			filtrosPessoa: new Pessoa(),


			idUsuario: 0,

			paginaAtualTabelaPessoas: 1,
			numeroDeLinhasTabelaPessoas: 0,
			pessoasPorPagina: 10,

			pessoas: [],
			pessoasFields: [],
			tipoPessoa: "pessoaJuridica",
			pessoaSelecionada: new Pessoa(),
			mostrarBuscarPessoa: true,
			tituloModal: "",

			cpfPessoaPesquisada: "",
			cnpjPessoaPesquisada: "",
			senha: "",
			confirmacaoSenha: "",
		};
	},

	methods: {
		setaCpfPessoaFisicaPesquisada(cpf) {
			this.cpfPessoaPesquisada = cpf;
		},
		setaCpfPessoaJuridicaPesquisada(cnpj) {
			this.cnpjPessoaPesquisada = cnpj;
		},
		verificaTipoPessoa(pessoa) {
			switch (pessoa.cpf) {
			case null:
				return "pessoaJuridica";

			default:
				return "pessoaFisica";
			}
		},
		buscarUsuarioPorId(id) {
			this.carregandoBuscarPorId = true;
			UsuarioService.consultarUsuarioPorId(id)
				.then((res) => {
					this.email = res.data.email;
					this.pessoaSelecionada.nome = res.data.nome;
					this.pessoaSelecionada.cnpj = res.data.cnpj;
					this.pessoaSelecionada.cpf = res.data.cpf;
					this.pessoaSelecionada.razaoSocial = res.data.razaoSocial;
					this.pessoaSelecionada.telefone = res.data.telefone;
					this.permissoes = res.data.permissoes[0];
				}).catch(() => {
					this.mensagem("Não foi possível concluir a operação");
				}).finally(() => {
					this.carregandoBuscarPorId = false;
				});
		},
		abrirModalNovoUsuario(idUsuario) {
			this.idUsuario = idUsuario;
			if (idUsuario == 0) {
				this.limparFormulario();
				this.filtrarPessoas();
				this.tituloModal = "Novo Usuário";
				this.$bvModal.show("modal-novo-usuario");
			} else {
				this.tituloModal = "Atualizar Usuário";
				this.mostrarBuscarPessoa = false;
				this.buscarUsuarioPorId(this.idUsuario);
				this.$bvModal.show("modal-novo-usuario");
			}
		},
		selecionaMascaraTelefone(value) {
			return value.length <= 10 ? "(##) ####-####" : "(##) #####-####";
		},
		salvarUsuario() {
			if (this.idUsuario == 0) {
				this.cadastrarUsuario();
			} else {
				this.atualizarUsuario();
			}
		},
		atualizarUsuario() {
			this.carregandoSalvarOficial = true;
			const form = {
				permissao: this.permissoes,
			};
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));

			AuthService.atualizarUsuario(form, this.idUsuario, usuarioLogado.id)
				.then(() => {
					this.$emit("input", true);
				})
				.then(() => {
		      	this.mensagem("Usuário atualizado com sucesso !", "Sucesso", "success");
					this.$bvModal.hide("modal-novo-usuario");
				}).catch((err) => {
		      	if (err.response) {
		      		this.mensagem(err.response.data, "Erro", "danger");
		      	} else {
		      		this.mensagem("Não foi possível atualizar o usuário !", "Erro", "danger");
		      	}
		      })
				.finally(() => {
					this.carregandoSalvarOficial = false;
				});
		},
		cadastrarUsuario() {
			this.carregandoSalvarOficial = true;
			const form = {
				email: this.email,
				idPessoa: this.idPessoa,
				permissao: this.permissoes,
				senha: this.senha,
				confirmacaoSenha: this.confirmacaoSenha,
			};
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));

		      AuthService.cadastrarUsuario(form, usuarioLogado.id)
			  .then(() => {
					this.$emit("input", true);
				})
			  .then(() => {
		      		this.mensagem("Usuário cadastrado com sucesso !", "Sucesso", "success");
					this.$bvModal.hide("modal-novo-usuario");
				})
				.catch((err) => {
		      	if (err.response) {
		      		this.mensagem(err.response.data, "Erro", "danger");
		      	} else {
		      		this.mensagem("Não foi possível cadastrar o usuário !", "Erro", "danger");
		      	}
		      })
				.finally(() => {
					this.carregandoSalvarOficial = false;
				});
		},
		setaColunasDasTabelas() {
			 if (this.tipoPessoa == "pessoaJuridica") {
			 	this.pessoasFields = [
			 		{ label: "#", key: "index" },
			 		{ label: "Razão Social", key: "razaoSocial" },
			 		{ label: "CNPJ", key: "cpfCnpj" },
			 		{ label: "Data de Cadastro", key: "dataInicio" },
					{ label: "Ação", key: "acao" },
			 	];
			 } else {
			 	this.pessoasFields = [
			 		{ label: "#", key: "index" },
			 		{ label: "Nome Completo", key: "nome" },
			 		{ label: "CPF", key: "cpfCnpj" },
			 		{ label: "Data de Cadastro", key: "dataInicio" },
					{ label: "Ação", key: "acao" },
			 	];
			 }
		},
		selecionarPessoa(value) {
			this.mostrarBuscarPessoa = false;
			this.pessoaSelecionada = value;
			this.idPessoa = this.pessoaSelecionada.id;
		},
		limparFormulario() {
			this.mostrarBuscarPessoa = true;
			this.filtrosPessoa = new Pessoa();
			this.email = "";
			this.senha = "";
			this.confirmacaoSenha = "";
			this.filtrarPessoas();
		},
		limparFiltros() {
			this.$refs.filtroPessoaFisica2.limpar();
			this.$refs.filtroPessoaJuridica2.limpar();
			this.cpfPessoaPesquisada = "";
			this.cnpjPessoaPesquisada = "";
		},

		reiniciaModal() {
			this.cpfPessoaPesquisada = "";
			this.cnpjPessoaPesquisada = "";
			this.tipoPessoa = "pessoaJuridica";
		},
		limparFormularioEPesquisar(tipoPessoa) {
			this.tipoPessoa = tipoPessoa;
			this.limparFiltros();
			this.mostrarBuscarPessoa = true;
			this.filtrosPessoa = new Pessoa();
			this.email = "";
			this.filtrarPessoas();
		},
		filtrarPessoas() {
			this.paginaAtualTabelaPessoas = 1;
			this.consultarPessoas();
		},
		consultarPessoas() {
			this.carregando = true;
			PessoaService
				.consultarPessoas(
					this.tipoPessoa,
					this.cpfPessoaPesquisada,
					this.cnpjPessoaPesquisada,
					this.paginaAtualTabelaPessoas - 1,
					this.pessoasPorPagina)
				.then((res) => {
					this.numeroDeLinhasTabelaPessoas = res.data[0];
					this.pessoas = res.data[1];
					this.setaColunasDasTabelas();
				}).catch((err) => {
					console.log(err);
					this.mensagem("Não foi possível realizar a consulta !", "Erro", "danger");
				}).finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/usuario/ModalSalvarUsuario.vue